module.exports = __webpack_public_path__ + "static/media/multiple-choice-letters-flea.70fcb55d.svg";